'use client'

/**
 * Invisible Cloudflare Turnstile Component
 * - Works seamlessly in production with HTTPS
 * - Gracefully disabled in development (localhost)
 * - No user interaction required
 */
export function Turnstile() {
  // Only render in production with HTTPS
  const isProduction =
    typeof window !== 'undefined' &&
    window.location.protocol === 'https:' &&
    process.env.NODE_ENV === 'production'

  if (!isProduction) {
    // Development mode - render nothing to avoid console errors
    return null
  }

  return (
    <div
      className="cf-turnstile"
      data-sitekey={process.env.NEXT_PUBLIC_CLOUDFLARE_TURNSTILE_SITE_KEY}
      data-theme="dark"
      data-size="normal"
      style={{
        opacity: 0,
        position: 'absolute',
        pointerEvents: 'none',
        height: 0,
        overflow: 'hidden',
      }}
    />
  )
}
